export const FETCH_LANDING_PAGE_FIELDS = "fetch_landing_page_fields";
export const FETCH_COLLECTION_PAGE_FIELDS = "fetch_collection_page_fields";
export const FETCH_CONFIGURATOR_PAGE_FIELDS = "fetch_configurator_page_fields";
export const FETCH_SUMMARY_PAGE_FIELDS = "fetch_summary_page_fields";
export const FETCH_COLLECTIONS = "fetch_collections";
export const TOGGLE_COLLECTION_PAGE_OVERLAY = "toggle_collection_page_overlay";
export const FETCH_MAIN_RINGS = "fetch_main_rings";
export const FETCH_HOLDER_RINGS = "fetch_holder_rings";
export const FETCH_RING_SHADOWS = "fetch_ring_shadows";
export const SELECT_ACTIVE_MAIN_RING = "select_active_main_ring";
export const SELECT_ACTIVE_HOLDER_RINGS = "select_active_holder_rings";
export const TOGGLE_MAIN_RING_COLLECTIONS = "toggle_main_ring_collection";
export const TOGGLE_HOLDER_RING_COLLECTIONS = "toggle_holder_ring_collections";
export const TOGGLE_MAIN_RING_MODAL = "toggle_main_ring_modal";
export const TOGGLE_HOLDER_RING_MODAL = "toggle_holder_ring_modal";
export const CLOSE_MODALS = "close_modals";
export const TOGGLE_EMAIL_MODAL = "toggle_email_modal";
export const SET_BUY_URL = "set_buy_url";
export const SET_SENDING_EMAIL_TEXT = "set_sending_email_text";
export const FETCH_COLLECTION_PAGE_NECKLACE_FIELDS =
  "fetch_collection_page_necklace_fields";
export const TOGGLE_COLLECTION_PAGE_NECKLACE_OVERLAY =
  "toggle_collection_page_necklace_overlay";
export const FETCH_NECKLACES = "fetch_necklaces";
export const FETCH_MEMORIES = "fetch_memories";
export const SELECT_ACTIVE_NECKLACE = "select_active_necklace";
export const ADD_ACTIVE_MEMORY_BY_INDEX = "add_active_memory_by_index";
export const REMOVE_ACTIVE_MEMORY_BY_INDEX = "remove_active_memory_by_index";
export const RESET_ACTIVE_MEMORIES = "reset_active_memories";
export const FETCH_CONFIGURATOR_PAGE_NECKLACE_FIELDS =
  "fetch_configurator_page_necklace_fields";
export const TOGGLE_NECKLACE_MODAL = "toggle_necklace_modal";
export const TOGGLE_MEMORY_MODAL = "toggle_memory_modal";
export const CLOSE_NECKLACE_MODALS = "close_necklace_modals";
export const SET_CALCULATE_NECKLACE_PRICE = "set_calculate_necklace_price";
export const SELECT_ACTIVE_MEMORY_IN_MODAL = "select_active_memory_in_modal";
export const TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL =
  "toggle_show_edit_memory_in_modal";
export const UPDATE_ACTIVE_MEMORY_ENGRAVING = "update_active_memory_engraving";
export const TOGGLE_MEMORY_COLLECTIONS = "toggle_memory_collections";
export const RESET_ACTIVE_EDIT_MEMORY = "reset_active_edit_memory";
export const TOGGLE_MEMORY_MODAL_WITH_MEMORY =
  "toggle_memory_modal_with_memory";
export const TOGGLE_EMAIL_SENT = "toggle_email_sent";
